import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { postPADAC010Integrate } from '../../services/Api';
import PADAA010 from './PADAA010';
import PADAB010 from './PADAB010';
import PADAC010 from './PADAC010';
import PADAD010 from './PADAD010';

const Register = () => {
    const [searchParams] = useSearchParams();
    const [currentStep, setCurrentStep] = useState(1);
    const [userData, setUserData] = useState({});
    const [statusIntegrated, setStatusIntegrated] = useState(false);
    const location = useLocation();
    const { username, password } = location.state || {};

    useEffect(() => {
        if (searchParams.get('integrated')) {
            setStatusIntegrated(true);
            setCurrentStep(2);
            postPADAC010Integrate({ memberID: username, password })
                .then(({ data }) => {
                    if (data.memberGbn !== 'P' && data.memberGbn !== 'C') {
                        data.memberGbn = 'P';
                    }
                    setUserData(data);
                })
                .catch((error) => console.log(error));
        }
        // eslint-disable-next-line
    }, []);

    const handleNextStep = (newData) => {
        setUserData({ ...userData, ...newData });
        setCurrentStep(currentStep + 1);
    };

    const handleResetStepToOne = () => {
        setCurrentStep(1);
    };

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <PADAA010 updateUserData={handleNextStep} userData={userData} onNext={() => setCurrentStep(2)} />
                );
            case 2:
                return (
                    <PADAB010
                        updateUserData={handleNextStep}
                        userData={userData}
                        onNext={() => setCurrentStep(3)}
                        statusIntegrated={statusIntegrated}
                    />
                );
            case 3:
                return (
                    <PADAC010
                        updateUserData={handleNextStep}
                        userData={userData}
                        onNext={() => setCurrentStep(4)}
                        handleResetStepToOne={handleResetStepToOne}
                        statusIntegrated={statusIntegrated}
                    />
                );
            case 4:
                return <PADAD010 userData={userData} />;
            default:
                return '';
        }
    };

    return (
        <div id="content">
            <div id="register-page">
                <div className="container">
                    <div className="content-box">
                        <div className="content-box__header">
                            <h2 className="content-box__title">회원가입</h2>
                        </div>
                        <div id="register-step">
                            <ul>
                                <li className={currentStep === 1 ? 'active' : ''}>1. 회원가입여부 확인</li>
                                <li className={currentStep === 2 ? 'active' : ''}>2. 통합회원 약관동의</li>
                                <li className={currentStep === 3 ? 'active' : ''}>3. 추가 정보 입력</li>
                                <li className={currentStep === 4 ? 'active' : ''}>4. 회원가입 완료</li>
                            </ul>
                        </div>
                        {renderStep()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
